var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-center" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.donie,
            expression: "donie"
          }
        ],
        staticClass: "donie"
      },
      [
        _c("img", {
          attrs: { src: require("../../static/donie.svg"), alt: "Donie" }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.donieCovered,
            expression: "donieCovered"
          }
        ],
        staticClass: "donie-covered"
      },
      [
        _c("img", {
          attrs: {
            src: require("../../static/donie-blindfolded.svg"),
            alt: "Donie olhos fechados"
          }
        })
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "box text-center text-purple" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("b", [_vm._v("Redefina sua senha")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.password,
            expression: "password"
          }
        ],
        ref: "password",
        staticClass: "with-icon icon-password mt-20 mb-20",
        attrs: { type: "text", placeholder: "sua senha", autocomplete: "off" },
        domProps: { value: _vm.password },
        on: {
          focus: function($event) {
            return _vm.donieCover()
          },
          blur: function($event) {
            return _vm.donieUncover()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.password = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.passwordConfirm,
            expression: "passwordConfirm"
          }
        ],
        staticClass: "with-icon icon-password mb-20",
        attrs: {
          type: "text",
          placeholder: "confirme sua senha",
          autocomplete: "off"
        },
        domProps: { value: _vm.passwordConfirm },
        on: {
          focus: function($event) {
            return _vm.donieCover()
          },
          blur: function($event) {
            return _vm.donieUncover()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.passwordConfirm = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-center mt-20" },
        [
          _c("router-link", { attrs: { to: "/login" } }, [
            _c("button", { staticClass: "btn bg-pink mb-10" }, [
              _vm._v("entrar")
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        attrs: { src: require("../../static/logo.svg"), alt: "Donamaid" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c6b805a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6b805a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Forgot.vue
// module id = null
// module chunks = 